import { combineReducers } from "redux";

import isLoadingReducer from "./isLoading";
import confirmInfoReducer from "./confirmInfo";
import usernameOfResetPasswordReducer from "./usernameOfResetPassword";

const rootReducer = combineReducers({
    isLoadingReducer,
    confirmInfoReducer,
    usernameOfResetPasswordReducer,
});

export default rootReducer
